import { useSessionStore } from './useSessionStore';
import { type CurrentUser } from '@types';

// Get the whole state
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const getSession = () => {
  return useSessionStore.getState();
};

// Get the token
export const getToken = (): string | null => {
  return useSessionStore.getState().authToken;
};

// Get the current user
export const getCurrentUser = (): CurrentUser | null => {
  try {
    return useSessionStore.getState().currentUser;
  } catch (err) {
    return null;
  }
};
